import classnames from 'classnames';
import React from 'react';
import Label from "../Label/Label";
import Col from "../Layout/Col";
import Required from "./components/Required";
import FormFeedback from "./FormFeedback";
import FormGroup from "./FormGroup";
import FormText from "./FormText";
var labelSizeTranslations = {
  sm: 2,
  md: 3,
  lg: 4
};
var defaultProps = {
  labelSize: 'md',
  width: {
    xs: 12
  }
};

function FormLabelGroup(_ref) {
  var children = _ref.children,
      feedback = _ref.feedback,
      hint = _ref.hint,
      inline = _ref.inline,
      inputId = _ref.inputId,
      label = _ref.label,
      _ref$labelSize = _ref.labelSize,
      labelSize = _ref$labelSize === void 0 ? defaultProps.labelSize : _ref$labelSize,
      required = _ref.required,
      rowClassName = _ref.rowClassName,
      size = _ref.size,
      srLabel = _ref.srLabel,
      stacked = _ref.stacked,
      validFeedback = _ref.validFeedback,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? defaultProps.width : _ref$width;
  var containerClassNames = classnames({
    'is-invalid': feedback,
    'is-valid': validFeedback
  }, rowClassName);
  var labelClassNames = classnames({
    'text-sm-end pe-0': !stacked,
    'text-danger': feedback,
    'text-success': validFeedback,
    'visually-hidden visually-hidden-focusable': srLabel
  });
  var hiddenClassNames = classnames({
    'is-invalid': feedback,
    'is-valid': validFeedback
  }, 'form-control');
  var labelWidth = stacked ? 12 : labelSizeTranslations[labelSize];
  var inputWidth = stacked || !label ? 12 : 12 - labelWidth;
  var valueWidth = stacked ? width : {
    xs: width.xs,
    sm: width.sm ? Math.min(inputWidth, width.sm) : inputWidth,
    md: width.md ? Math.min(inputWidth, width.md) : undefined,
    lg: width.lg ? Math.min(inputWidth, width.lg) : undefined,
    xl: width.xl ? Math.min(inputWidth, width.xl) : undefined
  };
  return /*#__PURE__*/React.createElement(FormGroup, {
    inline: inline,
    row: true,
    className: containerClassNames
  }, label && /*#__PURE__*/React.createElement(Label, {
    for: inputId,
    sm: labelWidth,
    size: size,
    className: labelClassNames
  }, label, required && label ? /*#__PURE__*/React.createElement(Required, null) : null), /*#__PURE__*/React.createElement(Col, valueWidth, children, (feedback || validFeedback) && /*#__PURE__*/React.createElement("div", {
    className: hiddenClassNames,
    hidden: true
  }), hint && /*#__PURE__*/React.createElement(FormText, {
    color: "muted"
  }, hint), feedback && /*#__PURE__*/React.createElement(FormFeedback, {
    className: "d-flex"
  }, feedback), validFeedback && /*#__PURE__*/React.createElement(FormFeedback, {
    className: "d-flex",
    valid: true
  }, validFeedback)));
}

FormLabelGroup.displayName = "FormLabelGroup";
export default FormLabelGroup;